import './DebugField.css';

import { Container, Form, Row } from 'react-bootstrap';
import React, { useEffect, useRef } from 'react';

import SegmentField from '../segment-field/SegmentField';

const DebugField = ({ data, sessionId }) => {
  const mainRef = useRef(null);

  useEffect(() => {
    if (data && mainRef) {
      mainRef.current.scrollIntoView();
    }
  }, [data, mainRef]);

  return (
    <Container ref={mainRef} className="border-radius-5">
      <h3>Debug Response</h3>
      <Container className="m-0 border-radius-5 bg-gray p-0">
        <h4 className="m-2">Full translated text</h4>
        <Row className="mt-1 bg-green" noGutters>
          <p className="translation-output-text ml-1">{data?.translatedText}</p>
        </Row>
        <h4 className="mt-2 ml-1">Segments ({data?.totalSegments})</h4>
        {data?.segmentsDebugOutput?.map((value, index) => {
          return <SegmentField key={index} data={value} isLuma={!!data?.lumaRoutingConfiguration} />;
        })}
        <h4 className="mt-2 ml-1">Info</h4>
        <Container className="debug-info">
          {sessionId && (
            <Row>
              <Form.Label>Session Id: {sessionId}</Form.Label>
            </Row>
          )}
          <Row>
            <Form.Label>Time: {data?.timeTookMs}ms</Form.Label>
          </Row>
          <Row>
            <Form.Label>Workflow Type: {data?.lumaRoutingConfiguration ? 'LLM (Luma)' : 'MTS'}</Form.Label>
          </Row>
          <Row>
            <Form.Label>MT Segment Count: {data?.segmentsMachineTranslated}</Form.Label>
          </Row>
          <Row>
            <Form.Label>TM Segment Count: {data?.segmentsTranslationMemoryMatched}</Form.Label>
          </Row>
          {data?.lumaRoutingConfiguration && (
            <>
              <Row>
                <Form.Label>Luma Model: {data?.lumaRoutingConfiguration?.modelId}</Form.Label>
              </Row>
              <Row>
                <Form.Label>Luma Prompt: {data?.lumaRoutingConfiguration?.promptId}</Form.Label>
              </Row>
              <Row>
                <Form.Label>Translation Type: {data?.lumaRoutingConfiguration?.translationType}</Form.Label>
              </Row>
            </>
          )}
          {data?.sourceDetectedLocale && (
            <Row>
              <Form.Label>Detected Source Language: {data?.sourceDetectedLocale}</Form.Label>
            </Row>
          )}
          {data?.machineTranslationRoutingConfiguration?.translationEngine && (
            <Row>
              <Form.Label>MT Engine: {data?.machineTranslationRoutingConfiguration?.translationEngine}</Form.Label>
            </Row>
          )}
          {data?.machineTranslationRoutingConfiguration?.model && (
            <Row>
              <Form.Label>MT Model: {data?.machineTranslationRoutingConfiguration?.model}</Form.Label>
            </Row>
          )}
        </Container>
      </Container>
    </Container>
  );
};

export default DebugField;
